import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../../context/AuthContext";

const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #0a0a0a;
  font-family: "Georgia", serif;
`;

const Sidebar = styled.aside`
  width: 220px;
  min-height: 100vh;
  background: #111;
  border-right: 1px solid #1e1e1e;
  display: flex;
  flex-direction: column;
  padding: 40px 0;
  position: fixed;
  top: 0;
  left: 0;
`;

const Brand = styled.div`
  padding: 0 28px 40px;
  border-bottom: 1px solid #1e1e1e;
  margin-bottom: 32px;
`;

const BrandTitle = styled.h1`
  color: #fff;
  font-size: 0.75rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  font-weight: 400;
  margin: 0 0 4px 0;
`;

const BrandSub = styled.p`
  color: #444;
  font-size: 0.65rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin: 0;
`;

const Nav = styled.nav`
  flex: 1;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const NavItem = styled(NavLink)`
  display: block;
  padding: 10px 12px;
  color: #555;
  text-decoration: none;
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  border: 1px solid transparent;
  transition: all 0.2s;

  &:hover {
    color: #ccc;
    border-color: #222;
  }

  &.active {
    color: #fff;
    border-color: #333;
    background: #161616;
  }
`;

const LogoutBtn = styled.button`
  margin: 0 16px;
  padding: 10px 12px;
  background: none;
  border: 1px solid #222;
  color: #444;
  font-size: 0.7rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: "Georgia", serif;
  text-align: left;
  transition: all 0.2s;

  &:hover {
    color: #c0392b;
    border-color: #c0392b;
  }
`;

const Main = styled.main`
  margin-left: 220px;
  flex: 1;
  padding: 48px;
  min-height: 100vh;
`;

const AdminLayout = ({ children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <Layout>
      <Sidebar>
        <Brand>
          <BrandTitle>Admin Panel</BrandTitle>
          <BrandSub>Studio Dashboard</BrandSub>
        </Brand>
        <Nav>
          <NavItem to="/admin/dashboard">Dashboard</NavItem>
          <NavItem to="/admin/products">Products</NavItem>
          <NavItem to="/admin/prices">Prices</NavItem>
          <NavItem to="/admin/orders">Orders</NavItem>
        </Nav>
        <LogoutBtn onClick={handleLogout}>Sign Out</LogoutBtn>
      </Sidebar>
      <Main>{children}</Main>
    </Layout>
  );
};

export default AdminLayout;
